/**
 * 默认配置文件
 */
export const ConnectOffset = 5

export const ATTR_LIST = ['class', 'style']

export const SPLIT_SYMBOL = {
  class: ' ',
  style: ';',
}

export const enum LayoutMenuDirection {
  Left = -1,
  Right = 1,
}
